import { ReactNode } from 'react';
import { Typography, DialogContent, SxProps, useTheme } from '@mui/material';
import BaseDialog, {
  SharedDialogProps,
} from 'components/Modals/BaseDialog/BaseDialog';

type FunctionalDialogProps = {
  description?: string;
  submitButtonStyle?: SxProps;
  buttonColor?: string;
  closeStyle?: SxProps;
  children?: ReactNode;
} & SharedDialogProps;

const FunctionalDialog = ({
  action,
  description,
  submitButtonStyle,
  buttonColor,
  closeStyle,
  children,
  ...otherProps
}: FunctionalDialogProps) => {
  const theme = useTheme();

  return (
    <BaseDialog
      action={action}
      submitButtonStyle={{
        marginLeft: theme.spacing(2),
        ...submitButtonStyle,
      }}
      closeStyle={closeStyle}
      buttonColor={buttonColor}
      {...otherProps}
    >
      <DialogContent
        data-testid="functional-dialog-description"
        sx={{ padding: theme.spacing(1, 0) }}
      >
        {description && (
          <Typography
            variant="body1"
            sx={{
              mb: theme.spacing(1),
              color: theme.palette.grey[900],
              whiteSpace: 'pre-line',
            }}
          >
            {description}
          </Typography>
        )}

        {children}
      </DialogContent>
    </BaseDialog>
  );
};

export default FunctionalDialog;
